import React from "react";
import { Modal, Table, Form, Button, Row, Col, OverlayTrigger, Tooltip } from "react-bootstrap";
import { XCircleFill } from "react-bootstrap-icons";
import Swal from "sweetalert2";
import { esalonariApi } from "../../../api/esalonariApi";

const ModalEsalonare = ({
  show,
  onHide,
  partidaActiva,
  dateEsalonare,
  setDateEsalonare,
  esteDepasit,
  totalEsalonat,
  restDeEsalonat,
  adaugaLuna
}) => {

  const handleStergeEsalonare = async (id, index) => {
    if (!id) {
      setDateEsalonare(prev => prev.filter((_, i) => i !== index));
      return;
    }
    try {
      const result = await Swal.fire({
        title: "Ești sigur?",
        text: "Vei șterge definitiv această lună din eșalonare!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Da, șterge-o!",
      });

      if (result.isConfirmed) {
        await esalonariApi.delete(id);
        const dateNoi = await esalonariApi.get(partidaActiva.id);
        setDateEsalonare(dateNoi.map(d => ({ id: d.id, luna: d.luna, volum: d.volum, suma: d.suma })));
        Swal.fire("Șters!", "Eșalonarea a fost eliminată.", "success");
      }
    } catch (err) {
      Swal.fire("Eroare", err.message, "error");
    }
  };

  const salveazaEsalonarea = async () => {
    const luniSelectate = dateEsalonare.map((d) => d.luna);
    const areDuplicate = luniSelectate.some((luna, index) => luniSelectate.indexOf(luna) !== index);

    if (areDuplicate) {
      return Swal.fire("Atenție", "Ai selectat aceeași lună de mai multe ori!", "warning");
    }

    try {
      const dateDeTrimis = {
        dateEsalonare: dateEsalonare.map((d) => ({
          id: d.id || null,
          luna: d.luna,
          volum: parseFloat(d.volum) || 0,
          suma: parseFloat(d.suma) || 0,
        })),
        partidaId: partidaActiva.id,
      };

      await esalonariApi.save(dateDeTrimis);
      Swal.fire("Succes", "Eșalonarea a fost salvată!", "success");
      const dateNoi = await esalonariApi.get(partidaActiva.id);
      setDateEsalonare(dateNoi.map(d => ({ id: d.id, luna: d.luna, volum: d.volum, suma: d.suma })));
    } catch (err) {
      Swal.fire("Eroare", "Eroare la salvarea eșalonării!", "error");
    }
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title>Eșalonare partida: {partidaActiva?.fond}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table size="sm" className="text-center" responsive>
          <thead>
            <tr>
              <th>Lună</th>
              <th>Volum (mc)</th>
              <th>Suma (RON)</th>
              <th>Ștergere</th>
            </tr>
          </thead>
          <tbody>
            {dateEsalonare.map((rand, index) => {
              const esteLunaDuplicata = dateEsalonare.some(
                (item, idx) => item.luna === rand.luna && idx !== index && rand.luna !== ""
              );

              return (
                <tr key={rand.id || index}>
                  <td>
                    <Form.Control
                      type="month"
                      value={rand.luna}
                      isInvalid={esteLunaDuplicata}
                      onChange={(e) => {
                        const noi = [...dateEsalonare];
                        noi[index].luna = e.target.value;
                        setDateEsalonare(noi);
                      }}
                    />
                    <Form.Control.Feedback type="invalid">Lună duplicată!</Form.Control.Feedback>
                  </td>
                  <td>
                    <Form.Control
                      type="number"
                      value={rand.volum === 0 ? "" : rand.volum}
                      isInvalid={esteDepasit}
                      onChange={(e) => {
                        const vStr = e.target.value;
                        const noi = [...dateEsalonare];
                        const vNum = vStr === "" ? 0 : parseFloat(vStr);
                        noi[index].volum = vNum;
                        noi[index].suma = vNum * (partidaActiva?.tarifBrut || 0);
                        setDateEsalonare(noi);
                      }}
                    />
                  </td>
                  <td>
                    <Form.Control type="number" value={rand.suma.toFixed(2)} readOnly className="bg-light" />
                  </td>
                  <td>
                    <Button variant="link" className="text-danger p-0 ms-2" onClick={() => handleStergeEsalonare(rand.id, index)}>
                      <XCircleFill size={18} />
                    </Button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>

        <Button variant="outline-success" onClick={adaugaLuna}>+ Adaugă Lună</Button>

        <div className={`mt-3 p-3 rounded border ${esteDepasit ? "bg-danger text-white border-danger" : "bg-light border-success"}`}>
          <Row>
            <Col><strong>Total Partidă:</strong> {partidaActiva?.volBrut?.toFixed(2)} mc</Col>
            <Col><strong>Eșalonat:</strong> {totalEsalonat.toFixed(2)} mc</Col>
            <Col className="text-end">
              {esteDepasit ? (
                <strong>⚠️ Depășire: {(totalEsalonat - partidaActiva.volBrut).toFixed(2)} mc</strong>
              ) : (
                <strong>Rămas: {restDeEsalonat.toFixed(2)} mc</strong>
              )}
            </Col>
          </Row>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <OverlayTrigger
          placement="top"
          overlay={partidaActiva?.stare === "reprimit" ? <Tooltip>Această partidă este deja reprimita.</Tooltip> : <></>}
        >
          <span className="d-inline-block">
            <Button
              variant="success"
              onClick={salveazaEsalonarea}
              disabled={esteDepasit || totalEsalonat === 0 || partidaActiva?.stare === "reprimit" || dateEsalonare.some((rand, idx) => dateEsalonare.some((item, i) => item.luna === rand.luna && i !== idx))}
            >
              Salvează eșalonările
            </Button>
          </span>
        </OverlayTrigger>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalEsalonare;